import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const SupplierProPurchase = createAsyncThunk(
  "Profile/Supplier_Pro_Purchase ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Profile/Supplier_Pro_Purchase `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcIDs: data.AcIDs ? data.AcIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SupplierProPayment = createAsyncThunk(
  "Profile/Supplier_Pro_Payment ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Profile/Supplier_Pro_Payment `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcIDs: data.AcIDs ? data.AcIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SupplierProItemQty = createAsyncThunk(
  "Profile/Supplier_Pro_Item_Qty ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Profile/Supplier_Pro_Item_Qty `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SupplierProItemAmt = createAsyncThunk(
  "Profile/Supplier_Pro_Item_Amt ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Profile/Supplier_Pro_Item_Amt `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SupplierProItemRate = createAsyncThunk(
  "Profile/Supplier_Pro_Item_Rate  ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Profile/Supplier_Pro_Item_Rate  `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SupplierProOutstanding = createAsyncThunk(
  "Profile/Supplier_Pro_Outstanding   ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Profile/Supplier_Pro_Outstanding   `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const SupplierSlice = createSlice({
  name: "FAS",
  initialState: {
    SupplierPurchasedata: null,
    SupplierPaymentdata: null,
    SupplierItemQtydata: null,
    SupplierItemAmtdata: null,
    SupplierItemRatedata: null,
    SupplierOutstandingdata: null,
    status: "idle",
    error: null,
  },
  reducers: {
    SupplierPurchaseFun: (state) => {
      state.SupplierPurchasedata = "no";
    },
    SupplierPaymentFun: (state) => {
      state.SupplierPaymentdata = "no";
    },
    SupplierItemQtyFun: (state) => {
      state.SupplierItemQtydata = "no";
    },
    SupplierItemAmtFun: (state) => {
      state.SupplierItemAmtdata = "no";
    },
    SupplierItemRateFun: (state) => {
      state.SupplierItemRatedata = "no";
    },
    SupplierOutstandingFun: (state) => {
      state.SupplierOutstandingdata = "no";
    },
    SupplierProItemQtyFun: (state) => {
      state.SupplierItemQtydata = "no";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SupplierProPurchase.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SupplierProPurchase.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SupplierPurchasedata = action.payload;
      })
      .addCase(SupplierProPurchase.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(SupplierProPayment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SupplierProPayment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SupplierPaymentdata = action.payload;
      })
      .addCase(SupplierProPayment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(SupplierProItemQty.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SupplierProItemQty.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SupplierItemQtydata = action.payload;
      })
      .addCase(SupplierProItemQty.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(SupplierProItemAmt.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SupplierProItemAmt.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SupplierItemAmtdata = action.payload;
      })
      .addCase(SupplierProItemAmt.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(SupplierProItemRate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SupplierProItemRate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SupplierItemRatedata = action.payload;
      })
      .addCase(SupplierProItemRate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(SupplierProOutstanding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(SupplierProOutstanding.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.SupplierOutstandingdata = action.payload;
      })
      .addCase(SupplierProOutstanding.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const {
  SupplierOutstandingFun,
  SupplierItemRateFun,
  SupplierItemAmtFun,
  SupplierItemQtyFun,
  SupplierPaymentFun,
  SupplierPurchaseFun,
  SupplierProItemQtyFun,
} = SupplierSlice.actions;

export default SupplierSlice.reducer;
